export default function PHP_is_countable() {
  return (
    <div>
      <h1>PHP_is_countable</h1>
    </div>
  );
}
